import init from "word_grid";
import { createRoot } from "react-dom/client";
import * as React from "react";
import {
    processAIRandomness,
    processProportionDictionary,
    Settings,
} from "../utils";
import { useState } from "react";
import { AI } from "../apis/ws_api";
import { API } from "../apis/api";
import { WasmAPI } from "../apis/wasm_api";
import { Game } from "../ui/Game";
import { Lobby } from "../ui/Lobby";

export function SingleplayerMenu(props: {
    settings: Settings;
    dictionary_text: string;
}) {
    const [game, setGame] = useState<React.JSX.Element>(null);
    const [ais, setAIs] = useState<AI[]>(() => {
        return [
            {
                proportion: processProportionDictionary(7),
                randomness: processAIRandomness(6),
            },
        ];
    });

    if (game == null) {
        return (
            <dialog open>
                <div className="new-game">
                    <Lobby
                        players={["Player"]}
                        ais={ais}
                        addAI={(x: AI) => {
                            ais.push(x);
                            setAIs(ais.slice());
                        }}
                        deleteAI={(i: number) => {
                            let filtered_ais = ais.filter((_x, j) => {
                                return i != j;
                            });
                            setAIs(filtered_ais);
                        }}
                    />
                    <div
                        className="flex-container"
                        style={{ paddingTop: "1em" }}
                    >
                        <button
                            onClick={() => {
                                const seed = new Date().getTime();
                                const game_wasm: API = new WasmAPI(
                                    BigInt(seed),
                                    props.dictionary_text,
                                    ais,
                                );
                                const game = (
                                    <Game
                                        settings={props.settings}
                                        api={game_wasm}
                                        key={seed}
                                        end_game_fn={() => setGame(null)}
                                    />
                                );
                                setGame(game);
                            }}
                        >
                            New Game
                        </button>
                    </div>
                </div>
            </dialog>
        );
    } else {
        return game;
    }
}

// @ts-ignore
const dictionary_url = new URL(
    "../../../resources/dictionary.csv",
    import.meta.url,
);

let dictionary_text: string = null;

async function run() {
    // First up we need to actually load the wasm file, so we use the
    // default export to inform it where the wasm file is located on the
    // server, and then we wait on the returned promise to wait for the
    // wasm to be loaded.
    //
    // It may look like this: `await init('./pkg/without_a_bundler_bg.wasm');`,
    // but there is also a handy default inside `init` function, which uses
    // `import.meta` to locate the wasm file relatively to js file.
    //
    // Note that instead of a string you can also pass in any of the
    // following things:
    //
    // * `WebAssembly.Module`
    //
    // * `ArrayBuffer`
    //
    // * `Response`
    //
    // * `Promise` which returns any of the above, e.g. `fetch("./path/to/wasm")`
    //
    // This gives you complete control over how the module is loaded
    // and compiled.
    //
    // Also note that the promise, when resolved, yields the wasm module's
    // exports which is the same as importing the `*_bg` module in other
    // modes
    await init();

    // need to retrieve the dictionary.csv file as text
    if (dictionary_text == null) {
        dictionary_text = await fetch(dictionary_url).then((response) => {
            return response.text();
        });
    }

    const root = createRoot(document.getElementById("root"));
    root.render(
        <SingleplayerMenu
            dictionary_text={dictionary_text}
            settings={{
                trayLength: 7,
                playerName: "Player",
            }}
        />,
    );
}

run().catch((error) => {
    console.error(error);
});
